import React, { useContext, useEffect, useState } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import DrinkMenuTable from "views/admin/drinkMenu/components/DrinkMenuTable";
import { columnsData } from "views/admin/menuItem/variables/columnsData";
import { AppContext } from "contexts/AppContext";

export default function DrinkMenu() {
  const options = [{ value: "1", label: "All Drink Menu Items" }];
  const [selectedOption, setSelectedOption] = useState("1");

  const { drinkMenuItemData, fetchDrinkMenuItemData } =
    useContext(AppContext);
  useEffect(() => {
    fetchDrinkMenuItemData();
  }, []);

  const optionMappings = {
    1: { tableData: drinkMenuItemData, title: "All Drink Menu Items" },
  };
  const selectedMapping = optionMappings[selectedOption];
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, md: 1 }}
        spacing={{ base: "20px", xl: "20px" }}
        width={"100%"}
      >
        {selectedMapping && drinkMenuItemData && (
          <DrinkMenuTable
            columnsData={columnsData}
            tableData={selectedMapping.tableData}
            title={selectedMapping.title}
            setSelectedOption={setSelectedOption}
            options={options}
          />
        )}
      </SimpleGrid>
    </Box>
  );
}
